module.exports = __webpack_public_path__ + "static/w3c-280e7cd1ed01f7148eaa7038249e5078.png";